import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import SEO from "../../components/SEO";
import { useLanguage } from "../../i18n/LanguageContext";

const NotFound = () => {
  const location = useLocation();
  const { t, path } = useLanguage();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  const pageStyle = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #2d2d2d 100%)',
    padding: '1.5rem'
  };

  const cardStyle = {
    textAlign: 'center' as const,
    maxWidth: '32rem'
  };

  const titleStyle = {
    fontSize: '5rem',
    fontWeight: 'bold',
    color: '#dfa926',
    margin: '0 0 1rem 0'
  };

  const subtitleStyle = {
    fontSize: '1.5rem',
    color: 'white',
    marginBottom: '1rem'
  };

  const textStyle = {
    color: '#9ca3af',
    marginBottom: '2rem',
    lineHeight: '1.6'
  };

  const buttonStyle = {
    backgroundColor: '#dfa926',
    color: 'black',
    fontWeight: '600',
    padding: '0.75rem 2rem',
    borderRadius: '0.5rem',
    textDecoration: 'none',
    display: 'inline-block',
    transition: 'background 0.2s'
  };

  return (
    <div style={pageStyle}>
      <SEO
        title={t('seo.notFound.title')}
        description={t('seo.notFound.description')}
        noindex
      />
      <div style={cardStyle}>
        <h1 style={titleStyle}>404</h1>
        <p style={subtitleStyle}>{t('notFound.title')}</p>
        <p style={textStyle}>
          {t('notFound.text')}
        </p>
        <Link
          to={path('/')}
          style={buttonStyle}
          onMouseEnter={(e) => (e.target as HTMLElement).style.backgroundColor = '#c8941f'}
          onMouseLeave={(e) => (e.target as HTMLElement).style.backgroundColor = '#dfa926'}
        >
          {t('notFound.home')}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
